import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useMiddlewareChangelogQuery } from '@composables/middleware/changelog-query.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const disciplineId = to.params.id

  if (typeof disciplineId !== 'string' || !disciplineId) return

  useMiddlewareChangelogQuery(to, {
    route: 'admin.disciplines.api.changelog',
    params: { discipline_id: disciplineId },
  })
})
